import type { Language } from '../i18n';

export function conversationDay(date: Date, now: Date): number {
  const start = (value: Date) =>
    new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
  return Math.round((start(now) - start(date)) / 86_400_000);
}

export type GroupKey = 'today' | 'yesterday' | 'week' | 'older';

export function groupOf(days: number): GroupKey {
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 8) return 'week';
  return 'older';
}

/** The right-hand label of a history row: the time today, the weekday this week, else the date. */
export function metaOf(date: Date, days: number, language: Language): string {
  const options: Intl.DateTimeFormatOptions =
    days <= 0
      ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }
      : days < 8
        ? { weekday: 'short' }
        : { day: 'numeric', month: 'short' };
  return new Intl.DateTimeFormat(language, options).format(date);
}
